import React, {CSSProperties} from "react";
import {ISegmentViewModel} from "../../../services/booking/models/segment/segment-view-model.interface";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";
import {
    IFlightDesignatorViewModel
} from "../../../services/booking/models/designator/flight-designator-view-model.interface";
import {HorizontalPlaneBox} from "../common/ticket-horizontal-plane.box";

const FlightNumberComponent: React.FC<{flightNumber: string}> = observer((props) => {
    const services = useServices();
    const styles: CSSProperties = {

        fontWeight: services.theme.currentTheme.fontWeight.bold
    };

    return (
        <div style={styles}>
            {services.language.translationFor('Flight number: {flightNumber}').withParams({flightNumber: props.flightNumber})}
        </div>
    )
})

const FlightDurationComponent: React.FC<{travelTime: string}> = observer((props) => {

    return (
        <div>
            {props.travelTime}
        </div>
    )
})

const CarrierComponent: React.FC<{designator: IFlightDesignatorViewModel}> = observer((props) => {
    const operatedByMessage = props.designator.getOperatedByMessage();
    if(!operatedByMessage) {
        return null;
    }

    return (
        <div>
            {operatedByMessage}
        </div>
    )
})


export const TicketSegmentFlightDetailsComponent: React.FC<{segment: ISegmentViewModel}> = observer((props) => {
    const services = useServices();
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: 'center',
        flexGrow: 1,
        gap: "4px"
    };


    return (
        <div style={styles}>
            <FlightNumberComponent flightNumber={props.segment.identifier.fullIdentifierCode()}/>
            <FlightDurationComponent travelTime={services.time.formatTravelTime(props.segment.designator.travelTime)}/>
            <HorizontalPlaneBox/>
            <CarrierComponent designator={props.segment.designator}/>
        </div>
    );
})
